<template>
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23 mb-20">클래스 상세정보</p>
                        <a class="float-right layer-close ml-30 pointer" @click="$emit('close')">
                            <img src="../../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <div class="hq-table-row">
                            <table>
                                <colgroup>
                                    <col width="30%">
                                    <col width="70%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>클래스명</th>
                                        <td>{{subject.subjectName || '-'}}</td>
                                    </tr>
                                    <tr>
                                        <th>언어</th>
                                        <td v-if="subject.language">{{ subject.language }}</td>
                                        <td v-else>-</td>
                                    </tr>
                                    <tr>
                                        <th>레벨</th>
                                        <td v-if="columnVisible.levelVisible">{{subject.level}}</td>
                                        <td v-else>-</td>
                                    </tr>
                                    <tr>
                                        <th>요일</th>
                                        <td v-if="columnVisible.dayVisible">{{formatDay(subject.day)}}</td>
                                        <td v-else>-</td>
                                    </tr>
                                    <tr>
                                        <th>스케줄</th>
                                        <td v-if="subject.subjectStartTime">{{subject.subjectStartTime}} ~ {{subject.subjectEndTime}}</td>
                                        <td v-else>-</td>
                                    </tr>
                                    <tr v-if="subject.place">
                                      <th>장소</th>
                                      <td v-if="subject.place">{{subject.place}}</td>
                                      <td v-else>-</td>
                                    </tr>
                                    <tr v-if="subject.teacher">
                                      <th>강사</th>
                                      <td v-if="subject.teacher">{{subject.teacher}}</td>
                                      <td v-else>-</td>
                                    </tr>
                                    <tr v-if="onPaymentPage">
                                        <th>교육비</th>
                                        <td v-if="columnVisible.eduPriceVisible">{{numberFormat(subject.eduPrice)}}</td>
                                        <td v-else>-</td>
                                    </tr>
                                    <tr v-if="subject.book">
                                      <th>교재</th>
                                      <td v-if="subject.book">{{subject.book}}</td>
                                      <td v-else>-</td>
                                    </tr>
                                    <tr v-if="onPaymentPage">
                                        <th>교재비</th>
                                        <td  v-if="columnVisible.bookPriceVisible">{{numberFormat(subject.bookPrice)}}</td>
                                        <td>-</td>
                                    </tr>
                                    <tr>
                                        <th>상세정보</th>
                                        <td class="whitespace-pre-wrap">{{subject.etc || '-'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    name:'detailModal',
    props: ['parentData'],
    data: () => ({
        subject: {}, // 과목 데이터
        onPaymentPage: true,
        columnVisible: {
            'languageVisible' : false,
            'levelVisible' : false,
            'dayVisible' : false,
            'subjectTimeVisible' : false,
            'eduPriceVisible' : false,
            'bookPriceVisible': false
        },
    }),

    mounted() {

        this.subject = this.parentData;
        // 결제 페이지가 있는지 확인
        var pOrder = JSON.parse(sessionStorage.getItem('pOrder'));
        if (pOrder.includes('payment')) {
            this.onPaymentPage = true;
        } else {
            this.onPaymentPage = false;
        }

        //신청정보 컬럼 세팅
        this.setColumnVisible();
    },

    methods: {
        // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
        numberFormat(inputNumber) {
            if (inputNumber) {
                return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return 0
            }
        },

        formatDay(stringDays) {
            if (stringDays && stringDays !== '') {
                return stringDays.replace(/\^/gi, ", ")
            } else {
                return '-'
            }
        },

        /**
         * @description : 신청정보 컬럼 visible 세팅
         */
        setColumnVisible(){
            const columnSplit = this.parentData.columnOrder.split('^');
            for(let i = 0 ; i < columnSplit.length ; i++){
                if(columnSplit[i] === '언어'){
                    this.columnVisible.languageVisible = true;
                }
                else if(columnSplit[i] === '레벨'){
                    this.columnVisible.levelVisible = true;
                }
                else if(columnSplit[i] === '요일'){
                    this.columnVisible.dayVisible = true;
                }
                else if(columnSplit[i] === '스케줄'){
                    this.columnVisible.subjectTimeVisible = true;
                }
                else if(columnSplit[i] === '교육비'){
                    this.columnVisible.eduPriceVisible = true;
                }
                else if(columnSplit[i] === '교재비'){
                    this.columnVisible.bookPriceVisible = true;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
